import { render, staticRenderFns } from "./isLink.vue?vue&type=template&id=74dd58bc&scoped=true&"
import script from "./isLink.vue?vue&type=script&lang=js&"
export * from "./isLink.vue?vue&type=script&lang=js&"
import style0 from "./isLink.vue?vue&type=style&index=0&id=74dd58bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd58bc",
  null
  
)

export default component.exports